
import { GlobalController } from 'src/shared/global/GlobalController'
import Vehicle from './Vehicle'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'vehicle',
    component: Vehicle,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
